import React from 'react';
import I18n from 'i18n-js';
import { IError } from '../schemas/core-schema';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import ScrollTarget from '@reverbdotcom/commons/src/components/scroll_target';
import { core_apimessages_Error } from '../schemas/rql';
import { decamelizeKeys } from 'humps';

export interface IProps {
  validationErrors: IError[];
}

export const CONVERT_SHOP_TYPE_CONTEXT = 'convert_shop_type';
export const ALREADY_CONVERTED_ERROR_TYPE = 'already_converted';

const renderValidationError = (error: IError, index: number) => {
  const message = resolveErrorMessage(error);
  return (
    <li className="shop-onboarding-errors__item" key={index}>
      <SanitizedRender
        html={message}
      />
    </li>
  );
};

const resolveErrorMessage = (error: IError) => {
  if (error.context && error.error_type) {
    return contextualErrorMessage(error);
  }
  return error.message;
};

const contextualErrorMessage = (error: IError) => {
  const { context, error_type } = error;

  if (context === CONVERT_SHOP_TYPE_CONTEXT && error_type === ALREADY_CONVERTED_ERROR_TYPE) {
    return I18n.t('discovery.convertShopType.validationErrors.alreadyConverted');
  }

  return I18n.t('discovery.coreOnboarding.validationErrors.default');
};

export default class ValidationErrors extends React.Component<IProps, null> {
  componentDidUpdate(prevProps) {
    if (
      this.props.validationErrors.length > 0 &&
        prevProps.validationErrors.length === 0
    ) {
      this.scrollToError();
    }
  }

  scrollToError() {
    if (this.refs.validationErrorsRef) {
      const typedScrollTarget = this.refs.validationErrorsRef as ScrollTarget;
      typedScrollTarget.scrollToTop();
    }
  }

  render() {
    const errors = this.props.validationErrors;

    if (!errors.length) {
      return null;
    }

    return (
      <div className="form-section">
        <ScrollTarget onlyScrollUp ref="validationErrorsRef" />
        <div className="shop-onboarding-errors">
          <h2 className="shop-onboarding-errors__title">
            {I18n.t('discovery.coreOnboarding.errors.title')}
          </h2>
          <p className="shop-onboarding-errors__subtitle">
            {I18n.t('discovery.coreOnboarding.errors.subtitle')}
          </p>
          <ul className="shop-onboarding-errors__items">
            {errors.map(renderValidationError)}
          </ul>
        </div>
      </div>
    );
  }
}

interface IRQLValidationErrorProps {
  validationErrors: core_apimessages_Error[];
}

export class RQLValidationErrors extends React.Component<IRQLValidationErrorProps, null> {
  render() {
    const rqlValidationErrors = this.props.validationErrors;
    const validationErrors = rqlValidationErrors.map(e => decamelizeKeys(e)) as IError[];
    return <ValidationErrors validationErrors={validationErrors} />;
  }
}
